import {
  SettingsIntegrationPageWrapper,
  SettingsIntegrationHeader,
  SettingsIntegrationScrollableArea,
  SettingsIntegrationSection,
} from "@/pages/settings/components/settings-integration-layout";
import { SettingsDebugAccountInfoForm } from "@/pages/settings/components/debug-account-info-form/settings-debug-account-info-form";
import { FC } from "react";

export const SettingsDebugAccountPage: FC = () => {
  return (
    <SettingsIntegrationPageWrapper>
      <SettingsIntegrationHeader breadcrumb="Debug" title="Debug account" />
      <SettingsIntegrationScrollableArea>
        <SettingsIntegrationSection>
          <SettingsDebugAccountInfoForm />
        </SettingsIntegrationSection>
      </SettingsIntegrationScrollableArea>
    </SettingsIntegrationPageWrapper>
  );
};
